export const PASSWORD_MIN_LEN = 10;

export function passwordPolicyError(pwd) {
  if (!pwd || pwd.length < PASSWORD_MIN_LEN) return `La contraseña debe tener al menos ${PASSWORD_MIN_LEN} caracteres`;
  if (!/[A-Za-z]/.test(pwd)) return "La contraseña debe incluir al menos una letra";
  if (!/\d/.test(pwd)) return "La contraseña debe incluir al menos un número";
  return null;
}

export const PASSWORD_HINT = `Mínimo ${PASSWORD_MIN_LEN} caracteres, con letras y números.`;
